export default {
  title: 'لیست فاکتور ها',
  search:'جستجو ...',
  id: 'شناسه',
  studentName: 'دانش آموز',
  studentMobile: 'موبایل',
  subtotal: 'مبلغ کل',
  totalDiscount: 'جمع تخفیف',
  totalPrice: 'مبلغ نهایی',
  shippingMethod: 'روش ارسال',
  paymentMethod: 'روش پرداخت',
  orderId: 'شماره سفارش',
  loading:'در حال دریافت اطلاعات ...',
  operating:'عملیات',
  empty:'داده ای یافت نشد',
  next: 'بعدی',
  previous: 'قبلی',
  success:'موفق',
}
